import Close from "@svg/close";
import { useEffect, useRef, useState, type FC } from "react";
import classNames from "classnames";
import { useAppContext } from "@context/app";
import { BANNER_OFFSET_HIDE } from "constants/layout-consts";
import dynamic from "next/dynamic";
import { useLayoutContext } from "@context/layout";
import FestivalBannerPicture from "./Picture";

const FestivalBannerCountDown = dynamic(() => import("./countdown"), {
  ssr: false,
});

const FestivalBanner: FC = () => {
  const { fetstivalBanner } = useLayoutContext();
  const { setShowFestivalBanner } = useAppContext();
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [isClosedByUser, setIsClosedByUser] = useState(false);
  const [isVisibleByScroll, setIsVisibleByScroll] = useState(true);

  const activeFestivalBanner = fetstivalBanner?.banner;

  useEffect(() => {
    const handleScroll = () => {
      if (!wrapperRef.current) return;
      setIsVisibleByScroll(
        window.scrollY < BANNER_OFFSET_HIDE + wrapperRef.current.offsetHeight
      );
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!activeFestivalBanner || isClosedByUser === true) return null;

  return (
    <div
      ref={wrapperRef}
      className={classNames(
        isVisibleByScroll ? "h-14" : "h-0",
        "w-full relative bg-white overflow-hidden flex items-center transition-all duration-150 ease-linear"
      )}
    >
      <Close
        fill="white"
        width={16}
        height={16}
        className="absolute z-30 top-2 right-3 cursor-pointer"
        onClick={() => {
          setIsClosedByUser(true);
          setShowFestivalBanner(false);
        }}
      />

      <FestivalBannerPicture />

      <div className="relative z-30 w-full max-w-[768px] px-3 mx-auto flex justify-end pointer-events-none">
        <FestivalBannerCountDown
          expireDate={activeFestivalBanner.time_period.expire_at}
          textColor={activeFestivalBanner.custom_details.clock_main_text_color}
          numberColor={
            activeFestivalBanner.custom_details.clock_main_number_color
          }
        />
      </div>
    </div>
  );
};

export default FestivalBanner;
